import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function ContactBoxWidget(props) {
    const { t } = useTranslation();
    const contacts = useSelector(store => store.contacts);

    if(!props?.title && !props?.address && !props?.phone && !props?.items) return null;

    return (
        <div data-test-id="addressbox-wr" className={"widget widget-addressbox" + (props?.dark ? " bg-dark" : "")}>
            <div className="container-xl row text-center mx-auto p-0">
                <div className="col-12 mb-72 mb-sm-40">
                    <h3 data-test-id="addressbox-title" className={(props?.dark ? "text-white " : "") + "mb-3"}>{props.title ? props.title : t('labels.address')}</h3>
                    {contacts?.address ? <p data-test-id="addressbox-address" className={(props?.dark ? "text-white " : "") + "text text-semibold"}>{contacts?.address}</p> : null}
                    {contacts?.phone ? <p data-test-id="addressbox-phone" className={(props?.dark ? "text-white " : "") + "text text-semibold mt-1"}>{contacts?.phone}</p> : null}
                </div>
                <div className="col-12">
                    {
                        props?.items && props?.items.length > 0 ?
                        <>
                            <h3 className={(props?.dark ? "text-white " : "") + "mb-3"}>{t('titles.follow_us')}</h3>
                            <div className="follow-us d-flex justify-content-center align-items-center">
                                {
                                    props.items.map((f, index) => {
                                        return (
                                            <div key={"cb_img_index" + index} className="mr-3">
                                                {
                                                    props?.dark ?
                                                        <SocialImg
                                                            dti={index}
                                                            key={"cb_light_img_" + index} 
                                                            path={f?.url}
                                                            img={f?.light_img}
                                                        />
                                                        :
                                                        <SocialImg
                                                            dti={index}
                                                            key={"cb_dark_img_" + index} 
                                                            path={f?.url}
                                                            img={f?.dark_img}
                                                        />
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                        : null
                    }
                </div>
            </div>
        </div>
    )
}

const SocialImg = (props) => {
    if(props?.img?.source){
        return (
            <img
                onClick={() => { 
                    if (props?.path) window.location.href = props.path; 
                }}
                data-test-id={"social-url-widget-" + props?.dti}
                className="w-100"
                src={props?.img?.source}
                alt={props?.img?.alt}
                title={props?.img?.title} />
        )
    }
    return (props?.img?.alt ?
        <p
            className='text-small'
            onClick={() => { if (props?.path) window.location.href = props.path }}
            data-test-id={"contactus-social-alt-" + props?.dti}
        >{props?.img?.alt}</p> 
        : 
        null)
}

ContactBoxWidget.propTypes = {
    title: PropTypes.string,
    descriptions: PropTypes.string,
    additional_text: PropTypes.string,
    button_text: PropTypes.string,
    path: PropTypes.string,
    img: PropTypes.string,
    position: PropTypes.string,
    widget: PropTypes.string,
    className: PropTypes.string,
};

export default ContactBoxWidget;
